<template>
  <div :class="$style.resourceContainer">
    <DropDownMenu
      :class="$style.reportDropDownMenu"
      :isFilterDropDown="true"
      :isLargeDropDown="false"
      :leftAlignList="true"
      :menuSections="menuSections"
      :menuTitle="currentReportTitle || ''"
      menuFontSize="small"
      :showMenuLabel="true"
    />
  </div>
</template>

<script>
import { ReportMenuLabels } from 'Reports/constants/reportsConstants';
import DropDownMenu from 'client/components/DropDownMenu/DropDownMenu.vue';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import ReportMetadata, { ReportTypes } from 'client/Reports/ReportMetadata';

export default {
  name: 'ReportTypeSelector',

  components: {
    DropDownMenu,
  },

  data: () => ({
    deviceReportLinks: [],
    filteredValues: [],
    userToResourceLinks: [],
    value: '',
  }),

  computed: {
    commandOptions() {
      return this.formatSelectData(this.commands, 'name', 'id');
    },

    currentReportTitle() {
      const { name } = ReportMetadata[this.value] || '';
      return name;
    },

    deviceGroupOptions() {
      return this.formatSelectData(this.deviceGroups, 'name', 'id');
    },

    devicesOptions() {
      return this.formatSelectData(this.devices, 'displayName', 'id');
    },

    menuSections() {
      const { handleMenuChange } = this;
      const formatMenuItems = reportTypes => reportTypes.map(report => ({
        label: report.name,
        action: handleMenuChange(report.value),
      }));

      this.checkFeatureFlagsAndAddReports();

      return [
        ...(this.userToResourceLinks.length > 0 ? [{
          menuLabel: ReportMenuLabels.userToResourceReports,
          menuItems: formatMenuItems(this.userToResourceLinks),
        }] : []),
        ...(this.deviceReportLinks.length > 0 ? [{
          menuLabel: ReportMenuLabels.deviceReports,
          menuItems: formatMenuItems(this.deviceReportLinks),
        }] : []),
      ];
    },
  },

  mounted() {
    this.setDefaultValue();
  },

  methods: {
    checkFeatureFlagsAndAddReports() {
      Object.values(ReportTypes).forEach(report => {
        const reportMetadata = ReportMetadata[report];

        if (reportMetadata.menuLabel === ReportMenuLabels.deviceReports
          && reportMetadata.isEnabled(this)) {
          this.deviceReportLinks.push({
            name: reportMetadata.name,
            value: reportMetadata.type,
          });
        } else if (reportMetadata.menuLabel === ReportMenuLabels.userToResourceReports
          && reportMetadata.isEnabled(this)) {
          this.userToResourceLinks.push({
            name: reportMetadata.name,
            value: reportMetadata.type,
          });
        }
      });
    },

    formatSelectData(data, nameAttribute, valueAttribute) {
      return data.map(item => ({
        name: item[nameAttribute],
        value: item[valueAttribute],
      }));
    },

    handleMenuChange(value) {
      return () => this.triggerReportChange(value);
    },

    setDefaultValue() {
      this.value = this.userToResourceLinks[0]?.value || this.deviceReportLinks[0]?.value;
      this.$emit('reportTypeSelectionEvent', this.value);
    },

    triggerReportChange(value) {
      this.$emit('reportTypeSelectionEvent', value);
      this.value = value;
      EventHelper.triggerReportTypeVisited({
        reportName: value,
      });
    },
  },
};
</script>

<style module>
@value (gradientDark2, gradientLight4, white) from '~css/colors.css';

.reportDropDownMenu {
  justify-content: flex-start;
}

.reportDropDownMenu .dropdownMenuList {
  left: 0;
}

.resourceContainer {
  display: flex;
  padding-bottom: 20px;
}

.reportLabel {
  background: gradientLight4;
  border-radius: 1.5rem;
  cursor: pointer;
  font-size: 1rem;
  margin-right: 1rem;
  padding: 0.5rem 1rem;
}

.selectedReport {
  background: gradientDark2;
  color: white;
}
</style>
